<template>
  <div>
    <SearchItem class="search-all" :list="historyList" title="历史搜索" value="清空搜索" :rightButton="clearHistory" @clickItem="toSearchItem"
      iconUrl="/img/home/search-history@2x.png">
    </SearchItem>
    <SearchItem class="search-all" :list="hotList" title="热门搜索" borderColor="#e20015"  @clickItem="toSearchItem"
      iconUrl="/img/home/search-hot@2x.png">
    </SearchItem>
  </div>
</template>

<script>
import SearchItem from './component/search-item.vue'
import cartApi from '@/api/cart'
import { mapState } from 'vuex'
export default {
  components: {
    SearchItem
  },
  data () {
    return {
      hotList: []
    }
  },
  created () {
    this.init()
  },
  computed: {
    ...mapState({
      historyList: state => state.search.historyList
    })
  },
  methods: {
    init () {
      this.$store.dispatch('search_a_getHistoryListData')
      this.getKeywordList()
    },
    // 获取搜索词
    getKeywordList () {
      this.hotList = []
      cartApi.getKeywordList().then(res => {
        if (res.data.resultCode === '0') {
          const { keywordList } = res.data.resultData
          keywordList.forEach(e => {
            this.hotList.push(e.wordLabel)
          })
        }
      })
    },
    // 清空搜索
    clearHistory () {
      this.$store.commit('search_m_clearHistoryListData')
    },
    toSearchItem (keyword) {
      this.$parent.setSearchKey(keyword)
    }
  }
}
</script>
<style scoped lang="less">
.search-all {
  margin-bottom: 0.2rem;
  background-color: #fff;
}
</style>
